/**
 * Building's own visibility domain: the two booleans (`is_private`, `show_on_customer_portal`)
 * collapsed into the filter keys, sort key and summary text the table and drawer display.
 *
 * Deliberately NOT in the shared `Attachments` surface. Every surface models "who can see this"
 * differently — Invoice uses a single `file_access` public/private value, Subcontractor documents
 * have no visibility concept at all — so this is config, not shared machinery.
 */
/** `[private ? 'hidden' : 'techs', ...(portal ? ['portal'] : [])]` — OR-matched by the Visibility filter. */
export function visibilityKeys(isPrivate, showOnCustomerPortal) {
    const keys = [isPrivate ? 'hidden' : 'techs'];
    if (showOnCustomerPortal)
        keys.push('portal');
    return keys;
}
/** `(private ? 0 : 1) + (portal ? 2 : 0)` — the exact sort key the design specifies. */
export function visibilitySortKey(isPrivate, showOnCustomerPortal) {
    return (isPrivate ? 0 : 1) + (showOnCustomerPortal ? 2 : 0);
}
export function visibilitySummaryKeyFor(isPrivate, showOnCustomerPortal) {
    if (isPrivate && !showOnCustomerPortal)
        return 'office_only';
    if (!isPrivate && !showOnCustomerPortal)
        return 'office_techs';
    if (isPrivate && showOnCustomerPortal)
        return 'office_portal';
    return 'office_techs_portal';
}
export function visibilitySummary(isPrivate, showOnCustomerPortal, translateFn) {
    return translateFn(`visibility_summary.${visibilitySummaryKeyFor(isPrivate, showOnCustomerPortal)}`);
}
